<template>
  <a-popover
    v-model:open="open"
    placement="bottomRight"
    destroyPopupOnHide
    trigger="click"
    @openChange="openChange"
  >
    <template #content>
      <div
        class="text-center text-[16px] leading-[1em] font-semibold text-font-1"
      >
        {{ $t('yao-qing-cheng-yuan-jia-ru-tuan-dui') }}
      </div>
      <a-divider style="margin: 12px -12px 0" class="w-[calc(100%+24px)]" />
      <div class="p-[16px] w-[320px]">
        <!-- <div class="text-12 text-font-50 mb-[10px]">
          {{
            $t(
              'fu-zhi-yi-xia-lian-jie-cheng-yuan-dian-ji-lian-jie-zhu-ce-deng-lu-hou-jia-ru-tuan-dui'
            )
          }}
        </div>
        <ShareLink
          :hasTitle="false"
          :url="link"
          :event="TRACK_EVENT.COPY_TEAM_MEMBER_INVITE_LINK"
          :trackParams="{
            team_id: userInfo?.organization_id,
            team_name: userInfo?.organization_name,
            operator_id: userInfo?.user_id,
            operator_name: userInfo?.username,
          }"
        /> -->
        <div class="text-12 text-font-50">
          <span v-if="userInfo?.is_expired" class="text-red-600">
            {{
              $t('dang-qian-tao-can-yi-guo-qi-qing-xu-fei-hou-ji-xu-shi-yong')
            }}
          </span>
          <span
            v-else
            :class="{
              'text-red-600': num === 0,
            }"
          >
            {{ $t('sheng-yu-num-ge-cheng-yuan-ming-e', [num]) }}
          </span>
          <a-alert v-if="num === 0" class="mt-[15px]" type="warning" show-icon>
            <template #message>
              <div v-if="isEnterprise">
                {{
                  $t(
                    'xi-wei-bu-zu-wu-fa-yao-qing-geng-duo-cheng-yuan-xie-tong-chuang-zuo-qing'
                  )
                }}
                {{ $t('lian-xi-nin-de-shang-wu-fu-ze-ren') }}。
              </div>
              <div v-else-if="isTeamLight">
                {{
                  $t(
                    'xi-wei-bu-zu-wu-fa-yao-qing-geng-duo-cheng-yuan-xie-tong-chuang-zuo-qing'
                  )
                }}
                <a href="javascript:void()" @click="showCurrentContact">{{
                  $t('lian-xi-wo-men')
                }}</a>
              </div>
              <div v-else-if="isTeamTaste">
                {{
                  $t(
                    'xi-wei-bu-zu-wu-fa-yao-qing-geng-duo-cheng-yuan-xie-tong-chuang-zuo-qing'
                  )
                }}
                <a href="javascript:void()" @click="showUpgradeModal">
                  {{ $t('sheng-ji') }}{{ $t('tuan-dui-ru-men-ban') }}
                </a>
                {{ $t('huo') }}
                <a href="javascript:void()" @click="showCurrentContact">{{
                  $t('lian-xi-wo-men')
                }}</a>
                {{ $t('sheng-ji') }}{{ $t('qi-ye-ban') }}
              </div>
            </template>
          </a-alert>
        </div>
        <a-button
          v-if="canAddSubAccount"
          size="small"
          type="primary"
          class="show-modal-button"
          @click="
            () => {
              open = false
              useAddSeats()
            }
          "
        >
          {{ $t('jia-gou-xi-wei-0') }}
        </a-button>
      </div>
    </template>
    <a-button type="primary">{{ $t('tian-jia-cheng-yuan') }}</a-button>
  </a-popover>
</template>

<script lang="ts" setup>
import { createInvitation } from '~/api'
import { USER_LEVEL_KEY } from '~/api/interface'
// import { ShareLink } from '~/features/template/components/shareLink'
import { showContact } from '~/hooks/useModal/modals/contact'
import { useAddSeats } from '~/features/paymentDesk/index.tsx'
import { useUpgrade } from '~/hooks/useUpgrade'
import { usePermission } from '~/hooks/usePermission.ts'
import { PageKey } from '~/constants/page'

const { $t } = useNuxtApp()

const open = ref(false)

const { canAddSubAccount } = usePermission()

const userInfo = useUserInfo()
const link = ref('')
const num = computed(() => {
  return userInfo.value?.rights?.sub_account_num || 0
})

const isEnterprise = computed(() =>
  [USER_LEVEL_KEY.ORG_STANDARD, USER_LEVEL_KEY.ORG_FLAGSHIP].includes(
    userInfo.value?.rights_type || USER_LEVEL_KEY.UN_AUTHORIZED
  )
)

const isTeamLight = computed(
  () => userInfo.value?.rights_type === USER_LEVEL_KEY.TEAM_LIGHT
)

const isTeamTaste = computed(
  () => userInfo.value?.rights_type === USER_LEVEL_KEY.TEAM_TASTE
)

const showUpgradeModal = () => {
  if (isGlobalVersion()) {
    return navigateTo({ name: PageKey.SUBSCRIBE })
  }

  useUpgrade()
}

const showCurrentContact = () => {
  showContact('yygw-tdxwbz-lxwm')
}

const openChange = async (v: boolean) => {
  if (userInfo.value?.is_expired || !v || num.value === 0) {
    return
  }

  try {
    const res = await createInvitation()
    if (res.code === 0) {
      link.value = `${location.origin}/center/invite?token=${res.data.token}`
    }
  } catch (error) {
    console.error(error)
  }
}

onBeforeMount(() => {
  useUpdateUser()
})
</script>

<style lang="scss" scoped>
.show-modal-button {
  position: absolute;
  right: 28px;
  top: 148px;
}
</style>
